import { 
    itemContext,
} from 'context'

class ClientWorkflow {
    constructor(props){
        let updatedProps = props || {}
        this.direction = updatedProps.direction || 'INFLOW';
        this.workflowId = updatedProps.workflowId;
        this.workflowTitle = updatedProps.workflowTitle || 'Untitled';
        this.userId = updatedProps.userId;
        this.channelId = updatedProps.channelId;
        this.active = updatedProps.active === undefined ? true : updatedProps.active;
        this.clientItemIds = updatedProps.clientItemIds || [];
        this.trigger = updatedProps.trigger || {
            trigger: updatedProps.trigger && updatedProps.trigger['trigger'],
            clientId: updatedProps.trigger && updatedProps.trigger['clientId'],
            client: updatedProps.trigger && updatedProps.trigger['client'],
            ext: updatedProps.trigger ? updatedProps.trigger['ext'] : {}
        };
        this.action = updatedProps.action || {
            action: updatedProps.action && updatedProps.action['action'],
            clientId: updatedProps.action && updatedProps.action['clientId'],
            client: updatedProps.action && updatedProps.action['client'],
            ext: updatedProps.action ? updatedProps.action['ext'] : {
                title: null,
                notes: [],
                pageID: null,
                sectionID: null,
                priority: itemContext.PRIORITY.NONE,
                tags: [],
                removeOnCancel: false,
                completeOnOver: false
            }
        };
        this.extinfo = updatedProps.extinfo ? updatedProps.extinfo : {}
        this.created = updatedProps.createdAt || new Date().toString().slice(0,24);
    }
}

export default ClientWorkflow
